import firebase from 'firebase/app';
import 'firebase/firestore';

class RatesService {
    #_fr = firebase.firestore();

    async getRates(){
        return await this.#_fr.collection("rates").get();
    }

    async updateRate(params: { docId: string, newData: any }) {
        return await this.#_fr.collection("rates").doc(params.docId).set(params.newData);
    }

    async createRate(params: { docId: string, newData: any }) {
        return await this.#_fr.collection("rates").doc(params.docId).set(params.newData, { merge: true });
    }

    async deleteRate(params: { docId: string, field: string }) {
        return await this.#_fr.collection("rates").doc(params.docId).set({
            [params.field]: firebase.firestore.FieldValue.delete(),
        }, { merge: true });
    }
}

export default RatesService;